import { render, staticRenderFns } from "./SecretaryProfile.vue?vue&type=template&id=a1919096&scoped=true"
import script from "./SecretaryProfile.vue?vue&type=script&lang=js"
export * from "./SecretaryProfile.vue?vue&type=script&lang=js"
import style0 from "./SecretaryProfile.vue?vue&type=style&index=0&id=a1919096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1919096",
  null
  
)

export default component.exports